import { UserService } from 'app/frontend/lib/shared/util/user';
import {Component, Inject, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {AuthService} from "../auth.service";
import {RedirectPathService} from "../../shared/util/redirect/redirect-path.service";
import {WINDOW} from "@teammood/shared/util/core";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

    email: string;
    show: string;
    main_button: any;
    message: {
        text: string,
        style: string
    };
    password: string;
    
    constructor(
        private authService: AuthService,
        private translate: TranslateService,
        @Inject(WINDOW) private window: Window,
        private userService: UserService,
        private redirectPathService: RedirectPathService
    ) { }

    ngOnInit() {
        this.begin_login()
    }

    begin_login() {
        this.show = "email";
        this.main_button = {
            label: this.translate.instant('next'),
            action: () => {
                this.authService.getAuthProvider(this.email).then(data => {

                    switch (data.auth_type) {
                        case 'saml':
                            this.window.location.href = data.redirect;
                            break;
                        case 'redirect':

                            this.message = {
                                text: 'Redirection...',
                                style: 'alert-info'
                            };

                            setTimeout(() => {
                                this.window.location.href = data.redirect;
                            }, 3000);

                            break;
                        default:

                            if (data.password_set) {
                                this.show = "password";
                                this.main_button = {
                                    label: this.translate.instant('login'),
                                    action: () => {
                                        this.password_auth();
                                    }
                                };

                                setTimeout(() => {
                                    const password_input = document.getElementById('password');
                                    if (password_input) {
                                        password_input.focus();
                                    }
                                }, 500);
                            } else {
                                this.show = "init_password";
                                this.main_button = {
                                    label: this.translate.instant('init_now'),
                                    action: () => {
                                        this.password_init();
                                    }
                                };
                            }
                    }
                });
            }
        };
    }

    password_auth() {
        this.authService
            .login({email: this.email, password: this.password})
            .then(async user => {
                this.userService.set(user);
                await this.redirectPathService.redirectOnLogin(user);
            })
            .catch((response) => {

                if (response.error.redirect) {
                    this.window.location.href = response.error.redirect;
                } else {
                    this.message = {
                        text: response.error,
                        style: 'alert-danger'
                    };
                }
            });
    }

    password_init() {
        this.authService.resetPassword(this.email)
            .then(() => {
                this.show = "password_initialized";
                this.main_button = {
                    label: "Back to login",
                    action: () => {
                        this.begin_login();
                    }
                };
            });
    }
}